const memory = new Map<string, string>();

export const storage = {
  get(key: string): string | null {
    try {
      const value = localStorage.getItem(key);
      if (value !== null) return value;
    } catch {
      // хранилище недоступно — читаем из памяти
    }

    return memory.get(key) ?? null;
  },

  set(key: string, value: string): void {
    memory.set(key, value);

    try {
      localStorage.setItem(key, value);
    } catch {
      // переживёт только текущую сессию
    }
  },

  remove(key: string): void {
    memory.delete(key);

    try {
      localStorage.removeItem(key);
    } catch {
      // нечего чистить
    }
  },
};
